import styled from 'styled-components';

const StyledMedicineDetailsAccordion = styled.div`
   overflow-y: auto;
`;

StyledMedicineDetailsAccordion.displayName = 'StyledMedicineDetailsAccordion';

export { StyledMedicineDetailsAccordion };
